import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Bicycles = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="bicycles"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.0625 36.6038C41.3406 36.6038 40.6386 36.6913 39.9658 36.8553L36.4113 28.2383L39.4948 27.2001C40.2316 26.952 40.6298 26.1476 40.3841 25.4033C40.1385 24.6592 39.3426 24.2566 38.6053 24.505L33.9905 26.0629C33.2736 26.3647 32.9346 27.1962 33.2333 27.9204L34.1168 30.0623L21.7913 33.2993L20.5253 30.3159H22.4813C23.2579 30.3159 23.8875 29.6799 23.8875 28.8955C23.8875 28.111 23.2579 27.475 22.4813 27.475H16.4562C15.6796 27.475 15.05 28.111 15.05 28.8955C15.05 29.6799 15.6796 30.3159 16.4562 30.3159H17.4653L19.3376 34.7282L16.6121 37.9402C15.2512 37.0932 13.65 36.6038 11.9376 36.6038C7.00941 36.6038 3 40.6536 3 45.6316C3 50.6095 7.00941 54.6593 11.9375 54.6593C16.3872 54.6593 20.0874 51.3574 20.7639 47.052H25.4936C25.9429 47.052 26.3651 46.8352 26.6299 46.4684L35.7008 33.9026L37.3706 37.9509C34.8246 39.5435 33.1248 42.3906 33.1248 45.6315C33.1248 50.6094 37.1341 54.6592 42.0623 54.6592C46.9904 54.6592 51 50.6095 51 45.6316C51 40.6536 46.9906 36.6038 42.0625 36.6038V36.6038ZM11.9375 51.8185C8.56022 51.8185 5.8125 49.043 5.8125 45.6316C5.8125 42.2201 8.56022 39.4447 11.9375 39.4447C12.9502 39.4447 13.9054 39.6958 14.7477 40.1372L10.8698 44.7072C10.5123 45.1284 10.4303 45.7212 10.6598 46.2252C10.8893 46.7292 11.3883 47.0521 11.9375 47.0521H17.8976C17.2603 49.7808 14.8309 51.8185 11.9375 51.8185V51.8185ZM14.995 44.2111L20.5724 37.6384L23.3611 44.2111H14.995ZM25.813 42.7782L22.9118 35.9403L32.5826 33.4004L25.813 42.7782ZM42.0625 51.8185C38.6852 51.8185 35.9376 49.043 35.9376 45.6316C35.9376 43.5738 36.9383 41.7485 38.473 40.6231L40.7644 46.178C41.0631 46.9021 41.8865 47.2445 42.6033 46.9428C43.3202 46.641 43.6592 45.8095 43.3605 45.0853L41.0679 39.5276C41.3918 39.4739 41.7237 39.4447 42.0624 39.4447C45.4398 39.4447 48.1874 42.2202 48.1874 45.6316C48.1874 49.0429 45.4398 51.8185 42.0625 51.8185V51.8185Z"
        fill={fill}
      />
      <path
        d="M15.0547 10.2734H13.4727C13.1814 10.2734 12.9453 10.5095 12.9453 10.8008V11.8555C12.9453 12.1467 13.1814 12.3828 13.4727 12.3828H15.0547C15.6361 12.3828 16.1094 11.9095 16.1094 11.3281C16.1094 10.7467 15.6361 10.2734 15.0547 10.2734Z"
        fill={fill}
      />
      <path
        d="M20.3633 5H7.63672C6.1829 5 5 6.1829 5 7.63672V20.3633C5 21.8171 6.1829 23 7.63672 23H20.3633C21.8171 23 23 21.8171 23 20.3633V7.63672C23 6.1829 21.8171 5 20.3633 5ZM15.0547 14.4922H12.9453V19.3086C12.9453 19.5998 12.7092 19.8359 12.418 19.8359H11.3633C11.072 19.8359 10.8359 19.5998 10.8359 19.3086V8.69141C10.8359 8.4001 11.072 8.16406 11.3633 8.16406H14.9298C16.46 8.16406 17.8657 9.1953 18.1574 10.6975C18.5497 12.7175 17.0057 14.4922 15.0547 14.4922Z"
        fill={fill}
      />
      <line x1="27" y1="54.5" x2="55" y2="54.5" stroke={stroke} strokeWidth="3" />
      <path d="M56 56C56 50.4772 52.1944 46 47.5 46C42.8056 46 39 50.4772 39 56" stroke={stroke} strokeWidth="3" />
    </svg>
  );
};
/* eslint-enable max-len */

Bicycles.defaultProps = {
  className: null,
};

Bicycles.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Bicycles;
